"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeCashResponseTapeArtifacts = exports.addCashResponseTapeArtifacts = void 0;
const lodash_1 = __importDefault(require("lodash"));
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
const { cloneDeep } = lodash_1.default;
const createCashResponseTape = (params) => {
    const { cashBalancesFeedContext, receivableResponseTape } = params;
    const { artifactDocumentId, creditFacilitySlug } = cashBalancesFeedContext;
    (0, common_1.finleyAssert)(creditFacilitySlug, 'creditFacilitySlug of cashBalancesFeedContext type must be defined');
    return {
        id: (0, uuid_1.v4)(),
        type: 'cashResponseTape',
        configuration: {
            cashBalancesFeedContextArtifactSlug: cashBalancesFeedContext.artifactSlug,
            receivableResponseTapeArtifactSlug: receivableResponseTape?.artifactSlug,
        },
        loanProductSlug: null,
        creditFacilitySlug,
        artifactDocumentId,
        externalFilename: null,
        artifactSlug: `cashResponseTape_${creditFacilitySlug}`,
    };
};
/**
 * Inserts new "CashResponseTape" artifact between "CashBalancesFeedContext & ReceivableResponseTape" and output artifact "BorrowingBaseReport"
 * Current: "CashBalancesFeedContext" --> "BorrowingBaseReport / etc."
 * Revised: "CashBalancesFeedContext & ReceivableResponseTape" --> "CashResponseTape" --> "BorrowingBaseReport / etc."
 */
const addCashResponseTapeArtifacts = (dbGraph) => {
    // Check for "CashBalancesFeedContexts", as they will act as our basis for this synthetic transaction
    // It there aren't, can simply just return back early since nothing to mutate
    const cashBalancesFeedContextsInGraph = utils.filterCashBalancesFeedContexts({
        dataTapes: dbGraph.dataTapes,
    });
    if (cashBalancesFeedContextsInGraph.length === 0) {
        return dbGraph;
    }
    const clonedDbGraph = cloneDeep(dbGraph);
    const { dataTapes } = clonedDbGraph;
    let { dataTapeDependencies } = clonedDbGraph;
    // get all ReceivableResponseTapes needed for receivables input to createCashResponseTape
    const receivableResponseTapesInGraph = utils.filterReceivableResponseTapes({
        dataTapes: dbGraph.dataTapes,
    });
    const receivableResponseTapeIds = receivableResponseTapesInGraph.map(({ id }) => id);
    for (const cashBalancesFeedContext of cashBalancesFeedContextsInGraph) {
        const { id, artifactSlug } = cashBalancesFeedContext;
        const cashBalancesFeedContextInputDependencies = utils.getDependenciesByInputId({
            dataTapeDependencies,
            inputArtifactId: id,
        });
        (0, common_1.finleyAssert)(cashBalancesFeedContextInputDependencies.length === 1, new common_1.error.FinleyError('cashBalancesFeedContext should only have 1 dependency to BorrowingBaseReport'));
        const cashBalancesFeedContextToBorrowingBaseDependency = cashBalancesFeedContextInputDependencies[0];
        const cashOutputArtifact = dataTapes.find((tape) => tape.id ===
            cashBalancesFeedContextToBorrowingBaseDependency.outputArtifactId);
        (0, common_1.finleyAssert)(cashOutputArtifact, `Failed to find output artifact for cashBalancesFeedContext [artifactSlug:${artifactSlug}], expected to find one`);
        // Recall that we won't have this if we're using "directInsertBorrowingBaseReport"
        // so no need to create these synthetic relationships for this
        let receivableResponseTape;
        if (cashOutputArtifact.type !== 'directInsertBorrowingBaseReport') {
            const receivableResponseTapeToBorrowingBaseDependencies = dataTapeDependencies.filter((dep) => receivableResponseTapeIds.includes(dep.inputArtifactId) &&
                dep.outputArtifactId ===
                    cashBalancesFeedContextToBorrowingBaseDependency.outputArtifactId);
            (0, common_1.finleyAssert)(receivableResponseTapeToBorrowingBaseDependencies.length === 1, new common_1.error.FinleyError(`receivableResponseTape should only have 1 dependency to BorrowingBaseReport [found:${receivableResponseTapeToBorrowingBaseDependencies.length}] when managing cashResponseTape [artifactSlug:${artifactSlug}]`));
            const receivableResponseTapeToBorrowingBaseDependency = receivableResponseTapeToBorrowingBaseDependencies[0];
            receivableResponseTape = dataTapes.find((dt) => dt.id ===
                receivableResponseTapeToBorrowingBaseDependency.inputArtifactId);
            (0, common_1.finleyAssert)(receivableResponseTape, new common_1.error.FinleyError('addCashResponseTapeArtifacts: receivableResponseTape should exist'));
        }
        const newCashResponseTape = createCashResponseTape({
            cashBalancesFeedContext,
            receivableResponseTape,
        });
        // Add new graph-edge between existing "CashBalancesFeedContext" to new "CashResponseTape"
        dataTapeDependencies.push({
            inputArtifactId: cashBalancesFeedContext.id,
            outputArtifactId: newCashResponseTape.id,
        });
        if (receivableResponseTape) {
            // Add new graph-edge between new "CashResponseTape" to existing "ReceivableResponseTape"
            dataTapeDependencies.push({
                inputArtifactId: receivableResponseTape.id,
                outputArtifactId: newCashResponseTape.id,
            });
        }
        // Removing existing dependency between "CashBalancesFeedContext" and output artifact "BorrowingBaseReport"
        dataTapeDependencies = utils.removeDependency({
            dataTapeDependencies,
            dependencyToRemove: cashBalancesFeedContextToBorrowingBaseDependency,
        });
        // Add new graph-edge between new "CashResponseTape" to existing output artifact "BorrowingBaseReport"
        dataTapeDependencies.push({
            inputArtifactId: newCashResponseTape.id,
            outputArtifactId: cashBalancesFeedContextToBorrowingBaseDependency.outputArtifactId,
        });
        // add cashResponseTape to dataTapes
        dataTapes.push(newCashResponseTape);
    }
    return { dataTapeDependencies, dataTapes };
};
exports.addCashResponseTapeArtifacts = addCashResponseTapeArtifacts;
/*

 * Current: "CashBalancesFeedContext" --> "CashResponseTape" --> "BorrowingBaseReport / etc."
 * Revised: "CashBalancesFeedContext" --> "BorrowingBaseReport / etc."
 */
const removeCashResponseTapeArtifacts = (dbGraph) => {
    const cashResponseTapesInGraph = utils.filterCashResponseTapes({
        dataTapes: dbGraph.dataTapes,
    });
    if (cashResponseTapesInGraph.length === 0) {
        return dbGraph;
    }
    const clonedDbGraph = cloneDeep(dbGraph);
    const { dataTapes } = clonedDbGraph;
    let { dataTapeDependencies } = clonedDbGraph;
    for (const cashResponseTape of cashResponseTapesInGraph) {
        // Remove synthetic "CashResponseTape" artifact from dataTapes
        const cashResponseTapeIndex = dataTapes.findIndex(({ id }) => id === cashResponseTape.id);
        (0, common_1.finleyAssert)(cashResponseTapeIndex !== -1, `Failed to find "CashResponseTape" in graph: [id: ${cashResponseTape.id}]`);
        dataTapes.splice(cashResponseTapeIndex, 1);
        // Fetch associated dependencies to "CashResponseTape"
        const cashBalancesFeedContext = utils.findArtifactBySlug({
            dataTapes,
            artifactSlug: cashResponseTape.configuration.cashBalancesFeedContextArtifactSlug,
        });
        dataTapeDependencies = utils.removeDependency({
            dataTapeDependencies,
            dependencyToRemove: {
                inputArtifactId: cashBalancesFeedContext.id,
                outputArtifactId: cashResponseTape.id,
            },
        });
        if (cashResponseTape.configuration.receivableResponseTapeArtifactSlug) {
            const receivableResponseTape = utils.findArtifactBySlug({
                dataTapes,
                artifactSlug: cashResponseTape.configuration.receivableResponseTapeArtifactSlug,
            });
            dataTapeDependencies = utils.removeDependency({
                dataTapeDependencies,
                dependencyToRemove: {
                    inputArtifactId: receivableResponseTape.id,
                    outputArtifactId: cashResponseTape.id,
                },
            });
        }
        const cashResponseTapeInputDependencies = utils.getDependenciesByInputId({
            dataTapeDependencies,
            inputArtifactId: cashResponseTape.id,
        });
        (0, common_1.finleyAssert)(cashResponseTapeInputDependencies.length === 1, `"CashResponseTape" in graph should only have 1 input dependency: [id: ${cashResponseTape.id}]`);
        dataTapeDependencies = utils.removeDependency({
            dataTapeDependencies,
            dependencyToRemove: {
                inputArtifactId: cashResponseTape.id,
                outputArtifactId: cashResponseTapeInputDependencies[0].outputArtifactId,
            },
        });
        // Add new graph-edge between new "CashBalancesFeedContext" to existing output "BorrowingBaseReport"
        dataTapeDependencies.push({
            inputArtifactId: cashBalancesFeedContext.id,
            outputArtifactId: cashResponseTapeInputDependencies[0].outputArtifactId,
        });
    }
    return { dataTapeDependencies, dataTapes };
};
exports.removeCashResponseTapeArtifacts = removeCashResponseTapeArtifacts;
//# sourceMappingURL=cashResponseTape.js.map